import React, { useEffect, useMemo, useState } from "react";
import { projects as raw } from "../data/projects";
import Tabs from "../components/projects/Tabs";
import ProjectCard from "../components/projects/ProjectCard";
import ProjectModal from "../components/projects/ProjectModal";
import Reveal from "../components/Reveal";

export default function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);

  // 기본 탭: all (URL에 #projects-group / #projects-personal 있으면 해당 탭)
  const tabFromHash = () => {
    const hash = window.location.hash;
    if (hash.includes("projects-group")) return "group";
    if (hash.includes("projects-personal")) return "personal";
    return "all";
  };
  const [tab, setTab] = useState(tabFromHash);

  // 탭 <-> 해시 동기화 (뒤로가기 기록 쌓지 않음)
  const changeTab = (next) => {
    setTab(next);
    const hash = next === "all" ? "#projects" : `#projects-${next}`;
    const url = new URL(window.location.href);
    url.hash = hash;
    window.history.replaceState(null, "", url.toString());
  };

  useEffect(() => {
    const onHash = () => setTab(tabFromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  // 카테고리 정규화 + 그룹핑
  const normalized = useMemo(
    () => raw.map((p) => ({ ...p, category: p.category ?? "personal" })),
    []
  );
  const grouped = useMemo(
    () => ({
      group: normalized.filter((p) => p.category === "group"),
      personal: normalized.filter((p) => p.category !== "group"),
    }),
    [normalized]
  );

  const items = tab === "group" ? grouped.group : tab === "personal" ? grouped.personal : normalized;

  return (
    <div className="mt-10">
      <h1 className="text-3xl font-bold mb-6 border-b-2 pb-2 border-blue-500 text-gray-900 dark:text-white">
        My Projects
      </h1>

      <Tabs
        tab={tab}
        counts={{ all: normalized.length, group: grouped.group.length, personal: grouped.personal.length }}
        onChange={changeTab}
      />

      <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-6">
        {items.map((project, i) => (
          <Reveal key={`${project.title}-${i}`} delay={(i % 3) * 100} className="h-full">
            <ProjectCard project={project} onOpen={setSelectedProject} />
          </Reveal>
        ))}
      </div>

      {selectedProject && (
        <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
      )}
    </div>
  );
}
